export default "__VITE_ASSET__f1cc1351__"